
import * as d3 from 'd3';
import { select } from 'd3-selection';
import store from '../../store';

const { getState } = store;

function createLegend(container, value, scale) {
  function legendCandidatos() {
    const legend = container
      .selectAll('.legenda')
      .data(value)
      .enter()
      .append('div')
      .attr('class', 'legenda__item');
    legend
      .append('h5')
      .attr('class', 'legenda__item__nome')
      .text(d => `${d.nome_candidato.toLowerCase()} (${d.sigla_partido})`);
    const legendBlock = legend
      .append('div')
      .attr('class', 'legenda__item__partido');

    // ITEM CONTAINER
    let legendBlockItem = legendBlock
      .append('div')
      .attr('class', 'partido__item');

    // BLACKGROUND COLOR
    legendBlockItem
      .append('span')
      .attr('class', 'partido__item__cor')
      .style('background-color', d => scale(d.numero_candidato))
      .append('span');

    // TEXTO
    legendBlockItem.append('span')
      .attr('class', 'partido__item__legenda')
      .text('Acima de 50%');

    // ITEM CONTAINER
    legendBlockItem = legendBlock
      .append('div')
      .attr('class', 'partido__item');

    // BLACKGROUND COLOR
    legendBlockItem
      .append('span')
      .attr('class', 'partido__item__cor')
      .style('background-color', d => scale(d.numero_candidato))
      .style('opacity', '.5');

    // TEXTO
    legendBlockItem.append('span')
      .attr('class', 'partido__item__legenda')
      .text('Abaixo de 50%');
  }

  function legendIndividual() {
    const width = 200;
    const height = 50;
    const svg = container.append('svg')
      .attr('width', width)
      .attr('height', height);

    // Espacamento das retas
    const x = d3.scaleLinear()
      .domain(scale.domain())
      .range([0, 40, 80, 120]);

    // Espacamento da label
    const b = d3.scaleLinear()
      .domain(scale.domain())
      .range([0, 160]);

    const g = svg.append('g')
      // .attr('class', '')
      .attr('transform', 'translate(20,0)')
      .attr('class', 'legend__percent__text');
    g.selectAll('rect')
      // Os dados da scala
      .data(scale.range()) // scale.domain()
      .enter()
      .append('rect')
      .attr('height', 20)
      .attr('x', (d, i) => x.range()[i])
      .attr('width', 40)
      // Aplicando 'recursivo'
      //  .style('fill', d => scale(d))
      // .attr('w', d => console.log(scale.invertExtent(d)))
      .style('fill', d => d);

    g.call(d3.axisBottom(b)
      .tickSize(30)
      .tickFormat(d => `${d}%`)
      .tickValues(scale.domain()))
      .select('.domain')
      .remove();
  }

  return {
    candidatos: legendCandidatos,
    individual: legendIndividual,
  };
}


export default () => {
  const { initial } = getState();
  const {
    param,
    data,
    list,
  } = initial;
  const { NEWDATA } = list;
  const { candidatos } = NEWDATA;
  const { vencedores } = data;
  const { currentKey, currentScale } = param;
  const { tooltip } = currentKey;
  const individual = document.querySelector('.legenda__candidato');
  if (tooltip === 'individual') {
    const { nome_candidato, sigla_partido } = candidatos[currentKey.param]; // eslint-disable-line
    individual.innerHTML = `<h4 class="candidato__nome">${nome_candidato.toLowerCase()} (${sigla_partido})</h4>`; // eslint-disable-line
  } else {
    individual.innerHTML = '';
  }
  const legendContainer = select('.legenda__svg');
  legendContainer.html('');
  const response = createLegend(legendContainer, vencedores, currentScale);
  response[currentKey.tooltip]();
};




// WEBPACK FOOTER //
// ./src/components/mapa/legend.js